<template>
    <div class="main_container" style="overflow: initial;">
        <div class="table_container supplier_main" v-loading="isLoading">
            <el-button-group>
                <el-tooltip :content="$t('message.Add')" class="item" effect="dark" placement="top">
                    <el-button @click="handleAdd" class="icon iconfont icon-xinzeng-wubiankuang"
                               type="primary"></el-button>
                </el-tooltip>
            </el-button-group>
            <el-table
                    :data="tableData"
                    :header-cell-style="{'background-color': '#f8f8f9', 'color': '#262626'}"
                    :row-key="row => row.index"
                    class="table_list table_border"
                    ref="multipleTable"
                    stripe>
                <el-table-column
                        :label="$t('message.SupplierName')"
                        prop="SupplierName">
                </el-table-column>
                <el-table-column
                        :label="$t('message.SupplierQuota')"
                        prop="Quota">
                </el-table-column>
                <el-table-column
                        :label="$t('message.SupplierStatus')"
                        prop="IsStop">
                    <template slot-scope="scope">
                        <span :class="{waite: scope.row.IsStop === 1}">
                            {{scope.row.IsStop === 1 ? $t('message.Deactivate') : $t('message.Enable')}}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('message.Operating')" width="90">
                    <template slot-scope="scope">
                        <el-tooltip
                                :content="$t('message.Edit')"
                                class="item"
                                effect="dark"
                                placement="top"
                        >
                            <el-button
                                    @click="handleEdit(scope.row)"
                                    class="hoverBtn iconfont icon-bianji-kong"
                            ></el-button>
                        </el-tooltip>
                        <el-tooltip
                                :content="$t('message.Delete')"
                                class="item"
                                effect="dark"
                                placement="top">
                            <el-button
                                    @click="handleDelete(scope.row)"
                                    class="hoverBtn iconfont icon-shanchu-kong"
                            ></el-button>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
            <div class="echarts_container">
                <div class="echart" id="lineCharts" style="width: 50%;height: 400px;"></div>
                <div class="echart" id="pieCharts" style="width: 50%;height: 400px;"></div>
            </div>
        </div>
        <el-dialog
                :title="$t('message.SupplierManage')"
                :visible.sync="dialogVisible"
                class="form_dialog"
                width="500px">
            <el-form :label-width="labelW" :model="supplierForm" :rules="supplierFormRules" ref="supplierForm">
                <el-form-item :label="$t('message.SupplierName')" prop="SupplierName">
                    <el-input placeholder=" "
                              v-model="supplierForm.SupplierName"></el-input>
                </el-form-item>
                <el-form-item :label="$t('message.SupplierQuota')" prop="Quota">
                    <el-input @blur="regMatch"
                              placeholder=" "
                              type="number"
                              v-model="supplierForm.Quota"></el-input>
                </el-form-item>
                <el-form-item :label="$t('message.SupplierStatus')" prop="IsStop" required>
                    <el-radio-group v-model="supplierForm.IsStop">
                        <el-radio :label="0">{{$t('message.Enable')}}</el-radio>
                        <el-radio :label="1">{{$t('message.Deactivate')}}</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <span class="dialog-footer" slot="footer">
                <el-tooltip :content="$t('message.Cancel')" class="item" effect="dark" placement="top">
                    <el-button @click="dialogVisible = false" class="iconfont icon-guanbi-wukuang"></el-button>
                </el-tooltip>
                <el-tooltip :content="$t('message.Save')" class="item" effect="dark" placement="top">
                    <el-button @click="doRole('supplierForm')" class="iconfont icon-baocun1" type="primary"></el-button>
                </el-tooltip>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import {GetSupplierQuota, SaveSupplier} from "../api/apiSupplier";
    import {getLocal} from "../config/mUtils";

    export default {
        name: 'supplier',
        components: {},
        data() {
            return {
                labelW: 0 + 'px',
                ruleForm: {
                    searchCondition: ''
                },
                supplierForm: {
                    SupplierName: '',
                    IsStop: 0,
                    Quota: ''
                },
                supplierFormRules: {
                    SupplierName: {
                        type: "string",
                        required: true,
                        message: this.$t("message.PleaseEnter") + this.$t("message.SupplierName"),
                        trigger: "blur"
                    },
                    Quota: {
                        type: "string",
                        required: true,
                        message: this.$t("message.PleaseEnter") + this.$t("message.SupplierQuota"),
                        trigger: "blur"
                    }
                },
                roleId: '',
                isLoading: false,
                tableData: [],
                dialogVisible: false,
            }
        },
        created() {
            this.getLanguageResourceForPage();
            this.initData();
            this.resetLabelWidth();
        },
        mounted() {
            this.setLineCharts();
            this.setPieCharts();
            window.addEventListener('resize', this.handlerSize);
        },
        computed: {
            canResetH() {
                return this.isShowMore;
            },
            langChange() {
                return this.$i18n.locale;
            }
        },
        watch: {
            watchHeight() {
                setTimeout(() => {
                    const that = this;
                    window.onresize = function temp() {
                        let widowHeight = document.documentElement.clientHeight - 237;
                        let h = document.getElementById('searchBox').clientHeight;
                        that.tableHeight = widowHeight - h;
                    };
                }, 1);
            },
        },
        methods: {
            resetLabelWidth() {
                if (getLocal('language') === 'zh-CN') {
                    this.labelW = 110 + 'px';
                } else {
                    this.labelW = 135 + 'px';
                }
            },
            // 窗口变化
            handlerSize() {
                this.setLineCharts();
                this.setPieCharts();
            },
            async initData() {
                try {
                    this.getSupplierQuota();
                } catch (err) {
                    console.log(err);
                }
            },
            // 获取角色列表
            async getSupplierQuota() {
                this.isLoading = true;
                this.tableData = [];
                try {
                    let data = await GetSupplierQuota();
                    if (data.error_code === '0') {
                        this.isLoading = false;
                        this.tableData = data.data;
                    } else {
                        this.isLoading = false;
                    }
                } catch (error) {
                    this.isLoading = false;
                    console.log(error);
                }
            },
            // 设置值规范
            regMatch(val) {
                let quota = parseInt(val.target.value);
                if (quota > 100 || quota < 10) {
                    this.$message.warning(this.$t('message.QuotaTips'));
                    this.supplierForm.Quota = '';
                }
            },
            // 新增
            handleAdd() {
                this.roleId = '';
                this.dialogVisible = true;
                this.supplierForm = {
                    SupplierName: '',
                    IsStop: 0,
                    Quota: ''
                };
                this.$nextTick(() => {
                    this.$refs['supplierForm'].resetFields();
                });
            },
            // 编辑
            handleEdit(row) {
                this.roleId = row.Id;
                this.dialogVisible = true;
                this.$nextTick(() => {
                    this.$refs['supplierForm'].resetFields();
                    this.supplierForm = {
                        SupplierName: row.SupplierName,
                        IsStop: row.IsStop,
                        Quota: row.Quota.toString()
                    };
                });
            },
            // 新增、编辑角色
            async saveSupplier(val) {
                try {
                    let data = await SaveSupplier(
                        this.roleId,
                        this.supplierForm.SupplierName,
                        val,
                        this.supplierForm.IsStop,
                        parseInt(this.supplierForm.Quota),
                        getLocal('language')
                    );
                    if (data.error_code === '0') {
                        if (val === 0) {
                            this.$message.success(this.$t('message.SaveSuccessful'));
                        } else {
                            this.$message.success(this.$t('message.DeleteSuccessful'));
                        }
                        this.dialogVisible = false;
                        this.getSupplierQuota();
                    } else {
                        this.$message.error(data.message);
                    }
                } catch (error) {
                    console.log(error);
                }
            },
            //保存
            doRole() {
                this.$refs['supplierForm'].validate((valid) => {
                    if (valid) {
                        this.saveSupplier(0);
                    }
                });
            },
            //生成折线图
            setLineCharts() {
                const lineChart = this.$echarts.init(document.getElementById("lineCharts"));
                let options = {
                    title: {
                        text: '2020年度使用量变化'
                    },
                    tooltip: {
                        trigger: 'axis'
                    },
                    legend: {
                        data: ['大象', '每刻']
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis: {
                        type: 'category',
                        boundaryGap: false,
                        data: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12']
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: [
                        {
                            name: '大象',
                            type: 'line',
                            stack: '总量',
                            data: [120, 132, 101, 134, 90, 230, 210, 120, 132, 101, 134, 90]
                        },
                        {
                            name: '每刻',
                            type: 'line',
                            stack: '总量',
                            data: [220, 182, 191, 234, 290, 330, 310, 191, 234, 290, 330, 310]
                        }
                    ]
                };
                lineChart.resize();
                lineChart.setOption(options);
                setTimeout(function () {
                    window.onresize = function () {
                        lineChart.resize();
                    }
                }, 200);
            },
            //生成饼图
            setPieCharts() {
                const pieChart = this.$echarts.init(document.getElementById("pieCharts"));
                let options = {
                    title: {
                        text: '2020年度使用量比例',
                        left: 'center'
                    },
                    tooltip: {
                        trigger: 'item',
                        formatter: '{b} : {c} ({d}%)'
                    },
                    legend: {
                        orient: 'vertical',
                        left: 'left',
                        data: ['大象', '每刻']
                    },
                    series: [
                        {
                            name: '访问来源',
                            type: 'pie',
                            radius: '55%',
                            center: ['50%', '60%'],
                            label: {
                                formatter: '{b|{b}}\n{hr|}\n{e|使用量：}{c|{c}}\n{f|使用比：}{per|{d}%}  ',
                                backgroundColor: '#eee',
                                borderColor: '#aaa',
                                borderWidth: 1,
                                borderRadius: 4,
                                padding: [0, 5],
                                rich: {
                                    hr: {
                                        borderColor: '#aaa',
                                        width: '100%',
                                        borderWidth: 0.5,
                                        height: 0
                                    },
                                    b: {
                                        fontSize: 16,
                                        lineHeight: 30,
                                        align: 'left'
                                    },
                                    c: {
                                        align: 'left'
                                    },
                                    per: {
                                        color: '#eee',
                                        backgroundColor: '#334455',
                                        padding: [2, 4],
                                        borderRadius: 2
                                    },
                                    e: {
                                        fontSize: 14,
                                        lineHeight: 30,
                                        align: 'left'
                                    },
                                    f: {
                                        fontSize: 14,
                                        lineHeight: 20
                                    }
                                }
                            },
                            data: [
                                {value: 335, name: '大象'},
                                {value: 10, name: '每刻'}
                            ],
                            emphasis: {
                                itemStyle: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                                }
                            }
                        }
                    ]
                };
                pieChart.resize();
                pieChart.setOption(options);
                setTimeout(function () {
                    window.onresize = function () {
                        pieChart.resize();
                    }
                }, 200)
            },
            // 删除
            handleDelete(row) {
                this.roleId = row.Id;
                this.supplierForm = row;
                this.saveSupplier(1);
            }
        }
    }
</script>

<style scoped>

</style>
